
<p>
  <span class="highlight"> LOS GEHT’S </span><br>
Es werden Dir typische Aussagen zum Thema Ausbildung & Studium gezeigt.
</p>
<p>
Stimmst Du der Aussage zu, klicke auf
<ion-icon
style="display:inline-block; vertical-align: text-bottom;"
src="assets/img/hand-thumbs-up.svg"
color="dark">
</ion-icon>
</p>
<p>
Stimmst Du der Aussage nicht zu, klicke auf
<ion-icon
style="display:inline-block; vertical-align: text-bottom;"
src="assets/img/hand-thumbs-down.svg"
color="dark">
</ion-icon>
</p>

